/*---------------------------------------------------------------------------------------------
 *  Copyright (c) i-Bridge Systems Philippines Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/
import { Box, Typography, Link } from '@mui/material';
import CopyrightIcon from '@mui/icons-material/Copyright';

import packageJson from '../../../package.json';

const { version } = packageJson;
const currentYear = new Date().getFullYear();

const style = {
  display: 'flex',
  justifyContent: 'center',
  mt: 'auto',
  position: 'absolute',
  bottom: 0,
  left: '50%',
  transform: 'translate(-40%, 0)',
  mb: 0.5,
};

export const Footer = (props) => {
  return (
    <Box sx={{ ...style, ...props.style }}>
      <CopyrightIcon
        fontSize="small"
        sx={{
          '&.MuiSvgIcon-root': {
            fill: '#FFF !important',
          },
        }}
      />
      <Typography variant="caption" sx={{ mx: 0.5 }}>
        {currentYear} i-BRIDGE SYSTEMS PHILIPPINES INC. All Rights Reserved. v
        {version}{' '}
        <Link href="https://forms.office.com/r/p86d8WFhti" target="_blank">
          Report an Issue.
        </Link>
      </Typography>
      {/* <Typography variant="caption">All Rights Reserved.</Typography> */}
    </Box>
  );
};
